import { getWatermarkedImgixUrl, isValidImageReference } from "services";
import { getAuctionDateTimes } from "../../propertyDetail/utils/getAuctionDateTimes";
import { PROPERTY_TYPE } from "../constants/auction";

// TODO: Data transformation, what is it frontend dependent? This should be moved to the backend while we are doing Typesense indexing. So that most of the transformation is at one place. Plan for it to move to the backend.
export const transformAuctionProperties = ({
  shortListedProperties,
  properties,
}: {
  shortListedProperties: any[];
  properties: any[];
}) => {
  return properties.map((property) => {
    const auctionDate = getAuctionDateTimes({
      propertyDateType: property?.property_date_type,
      dateTimeString: property?.auction_start_date_time,
      isAuctionConducted: property?.auction_by_ab,
      isAuctionStartDateOnly:
        property?.date_only_flags?.is_auction_start_date_only,
      variant: "short",
      showIST: false,
    });

    const tagRelatedData = {
      isTagged: property?.interested_count > 0,
      tag:
        property?.property_date_type === "undated"
          ? "Coming Soon"
          : property?.property_date_type === "private_treaty"
          ? "Private Treaty"
          : undefined,
      showTagText:
        property?.property_date_type === "undated"
          ? false
          : property?.property_date_type === "private_treaty"
          ? false
          : true,
      tagText: property?.interested_count
        ? `${property?.interested_count}+ people shortlist this property`
        : undefined,
    };

    const sellerRelatedData = {
      bankName: property?.dump.bank.bank_name,
      bankLogo: property?.dump?.bank?.bank_logo
        ? `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${property?.dump?.bank?.bank_logo}?w=32&h=32&auto=format`
        : undefined,
    };

    const imageFromDumpData = property?.dump?.property_image;
    const imageFromDumpAssetData = property?.dump?.asset?.placeholder_image;

    const imageUuid = imageFromDumpData || imageFromDumpAssetData;

    const propertyImageUrl = imageUuid
      ? getWatermarkedImgixUrl(
          `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${imageUuid}`,
        )
      : "";

    const hasImage = isValidImageReference(propertyImageUrl);

    const imageRelatedData = {
      hasImage: hasImage,
      propertyImageUrl: propertyImageUrl,
      showRequestImagesCta: !imageFromDumpData,
    };

    return {
      propertyType: PROPERTY_TYPE.AUCTION,
      listingId: property?.listing_id,
      title: `${property?.dump?.asset?.sub_asset_type_name} in ${property?.dump?.location?.city_name}`,
      possession: property?.possession_type || "Physical",
      priceTag: "Reserve Price",
      price: property?.reserve_price,
      area: property?.area || "NA",
      auctionDate: auctionDate || "TBD",
      ...imageRelatedData,
      ...tagRelatedData,
      ...sellerRelatedData,
      isVerified: property?.ab_verified,
      isLiked: shortListedProperties?.includes(property?.uuid),
    };
  });
};
